// export const typesWindow = {
//   windowProjects: "windowProjects",
//   windowAboutMe: "windowAboutMe",
//   windowCV: "windowCV",
//   windowContact: "windowContact",
// };

export const typesWindow = {
  profile: "profile",
  projects: "projects",
  contact: "contact",
  about: "about",
  welcome: "welcome",
};
